"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterMetricManagement = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const notification_service_1 = require("./notification.service");
const order_by_pipe_1 = require("./order-by.pipe");
const filter_metric_service_1 = require("./filter-metric.service");
const permission_service_1 = require("./permission.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
//VARIABLE MODELS
const filter_metric_type_1 = require("./filter-metric-type");
const data_source_1 = require("./data-source");
let FilterMetricManagement = class FilterMetricManagement {
    constructor(_talk, _filterMetric, _bidFilters, _permission, _orderBy) {
        this._talk = _talk;
        this._filterMetric = _filterMetric;
        this._bidFilters = _bidFilters;
        this._permission = _permission;
        this._orderBy = _orderBy;
        this.filterSearchTerm = '';
        this.filterMetrics = [];
        this.clientOptions = [];
        this.selectedClients = [];
        this.totalFiltersCount = 0;
        this.currentPage = 1;
        this.itemsPerPage = 50;
        this.paginationId = 'listPagination';
        // Loading States 
        this.loadingData = false;
        this.submittingUpdate = false;
        this.dataRequestFailed = false;
    }
    ngOnInit() {
        this.loadInitData();
    }
    loadInitData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.permission = this._permission.get();
            this.paginationId = `${this.paginationId}-${this.dataSource.slug}-${this.filterType.slug}`;
            try {
                this.loadingData = true;
                this.clientOptions = this.buildClientOptions(this.clients);
                this.clientsMapping = this.getClientsMapping(this.clients);
                yield this.requestAndLoadNewData(); //Make request to load initial filters
                this.loadingData = false;
            }
            catch (err) {
                this.loadingData = false;
                this.dataRequestFailed = true;
                // console.warn('Unable to get some of filters data', err.message);
            }
        });
    }
    onInputSearch(value) {
        if (value) {
            // wait to load the new searched values
            // and then update the filterSearch state so the new loaded
            // are also displayed
            this.requestAndLoadNewData(value)
                .then(() => this.filterSearchTerm = value);
        }
        else {
            // just update the search
            // for the current values 
            this.filterSearchTerm = value;
            this.requestAndLoadNewData(this.filterSearchTerm);
        }
    }
    getClientsMapping(clients = []) {
        return clients.reduce((clientsMap, client) => {
            clientsMap[client.id] = client.name;
            return clientsMap;
        }, {});
    }
    onFilterClientSelected(client) {
        this.requestAndLoadNewData(this.filterSearchTerm);
    }
    requestAndLoadNewData(searchValue) {
        return this.requestNewSearchData(searchValue, this.currentPage)
            .then(newMetrics => this.loadNewSearchedData(newMetrics));
    }
    /**
     * Verify and load the new filters that are not already loaded
     */
    loadNewSearchedData(newFilterData) {
        if (newFilterData) {
            const { filters, totalFiltersCount } = newFilterData;
            this.filterMetrics = filters;
            this.totalFiltersCount = totalFiltersCount || 0;
        }
    }
    requestNewSearchData(searchValue, page) {
        return __awaiter(this, void 0, void 0, function* () {
            const filterSource = this.dataSource.slug;
            const queryParams = {
                limit: this.itemsPerPage,
                type: [this.filterType.id],
                value: searchValue,
                client: this.selectedClients && this.selectedClients.length ? this.selectedClients : null,
                page
            };
            try {
                this.loadingData = true;
                const newFiltersData = yield this._filterMetric.adminPull({ filterSource, queryParams });
                this.loadingData = false;
                return (newFiltersData && newFiltersData.length === 1) ? newFiltersData[0] || {} : newFiltersData || {};
            }
            catch (err) {
                // console.error('Unable to load filters data', err);
                this.loadingData = false;
                this.dataRequestFailed = true;
            }
        });
    }
    toggleEnabledFilterMetric(filterMetric) {
        if (filterMetric && !this.submittingUpdate) {
            filterMetric.enabled = !filterMetric.enabled;
            return this.submitFilterUpdate(filterMetric);
        }
    }
    toggleDeletedFilterMetric(filterMetric) {
        if (filterMetric && !this.submittingUpdate) {
            filterMetric.deleted = !filterMetric.deleted;
            return this.submitFilterUpdate(filterMetric);
        }
    }
    pageChanged($event) {
        this.currentPage = $event;
        this.requestAndLoadNewData(this.filterSearchTerm);
    }
    buildClientOptions(clients = []) {
        return this._orderBy.transform(clients.map(org => ({ id: org.id, displayName: org.name, name: org.name })), ['displayName']);
    }
    clientLookUp(id) {
        return this.clients.find(client => client.id == id).name;
    }
    reloadInitState() {
        this.filterSearchTerm = '';
        this.selectedClients = [];
        this.loadInitData();
        // any other resets ...
    }
    /**
     * Submit the filters changes to server side
     */
    submitFilterUpdate(filterMetric) {
        return __awaiter(this, void 0, void 0, function* () {
            this.submittingUpdate = true;
            try {
                const filterChanges = this._bidFilters.omitOptionalKeys(filterMetric, ['client', 'createdAt', 'updatedAt']);
                const response = yield this._bidFilters.update(this.filterType.slug, this.dataSource.slug, filterChanges, filterMetric.id);
                this.submittingUpdate = false;
                this.displayUpdateResponse(response || {});
                if (response.failed && response.failed.length) {
                    // reload data view failed updates
                    yield this.requestAndLoadNewData();
                }
            }
            catch (err) {
                this.submittingUpdate = false;
                this._talk.broadcast(`We had some problem submitting the update request for ${filterMetric.value || ' this filter.'}. Please try again!`);
                this.requestAndLoadNewData();
            }
        });
    }
    displayUpdateResponse({ updated, failed }) {
        let updatesMsg = '';
        if (updated && updated.length) {
            updated.map(update => this.buildAlertMsgLi(update, 'updated'));
        }
        else if (failed && failed.length) {
            failed.map(update => this.buildAlertMsgLi(update, 'failed'));
        }
        if (updatesMsg) {
            this._talk.broadcast(`<ul>${updatesMsg}</ul>`);
        }
    }
    buildAlertMsgLi(filter, status = 'updated') {
        if (status === 'updated')
            return `<li>Succesfully updated filter ${filter.value}(${filter.id}).</li>`;
        else
            return `<li>Unable to update filter ${filter.value}(${filter.id}).</li>`;
    }
    getFilterClientName(filter) {
        if (filter.client.name)
            return filter.client.name;
        if (typeof filter.client === 'number') //main key its id
            return this.clientsMapping[filter.client];
        else if (typeof filter.client.id !== 'undefined')
            this.clientsMapping[filter.client.id];
        else
            return '';
    }
};
exports.FilterMetricManagement = FilterMetricManagement;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", filter_metric_type_1.FilterMetricType)
], FilterMetricManagement.prototype, "filterType", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], FilterMetricManagement.prototype, "clients", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", data_source_1.DataSource)
], FilterMetricManagement.prototype, "dataSource", void 0);
exports.FilterMetricManagement = FilterMetricManagement = __decorate([
    (0, core_1.Component)({
        selector: 'filter-metric-management',
        templateUrl: 'app/filter-metric-management.component.html',
        styleUrls: ['../styles/less/filter-metric-management.component.less'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        filter_metric_service_1.FilterMetricService,
        bid_data_filter_service_1.BidDataFilterService,
        permission_service_1.PermissionService,
        order_by_pipe_1.OrderByPipe])
], FilterMetricManagement);
//# sourceMappingURL=filter-metric-management.component.js.map